// Temporary: Remove this entire file after Breeze Assistant MCP beta rollout is complete.
// Once removed, make BreezeAssistantAlert the default in McpServerConnectAlert.tsx.
import enviro from 'enviro';
import { useDetailsPageContext } from 'marketplace-ui-common/context/DetailsPageContext';
const QA_LISTING_IDS = [2763714,
// Notion
3350670,
// Gong
3350541,
// Amplitude
3350161 // G2
];
const PROD_LISTING_IDS = [
  /* TODO: Add prod listing IDs here */
];
export function useBreezeAssistantBetaListing() {
  const {
    listingId
  } = useDetailsPageContext();
  const ids = enviro.isQa() ? QA_LISTING_IDS : PROD_LISTING_IDS;
  return ids.indexOf(listingId) !== -1;
}